/**
 * @generated SignedSource<<be48f02a03e9f1f40446f2c19c0ff850>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SaveSearchButton_favoritesConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly __id: string;
      readonly serviceId: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "SaveSearchButton_favoritesConnection";
};
export type SaveSearchButton_favoritesConnection$key = {
  readonly " $data"?: SaveSearchButton_favoritesConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_favoritesConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SaveSearchButton_favoritesConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "favoritesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Favorite",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "favoritesConnection",
  "abstractKey": null
};

(node as any).hash = "4fd0498fca38d49ce5a2bbac1475b6a7";

export default node;
